import Currencies from '@shared/data/currency.json';

export default function formatCurrency(amount: number, currencyCode: keyof typeof Currencies) {
	if (!Currencies[currencyCode]) throw new Error('Currency code not found');

	const composedAmount = amount / 10 ** Currencies[currencyCode].decimal_digits;
	const formattedAmount = Intl.NumberFormat('nl', {
		style: 'currency',
		currency: currencyCode || 'EUR',
	}).format(composedAmount);

	return formattedAmount;
}
